import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';

export const GET_THEME = gql`
    query Theme {
        theme @client
    }
`;

export default () => useQuery(GET_THEME);